// Typelizer digest 96788950c7eb4693578fb732f2754ac0
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /c/:company_id/overview/match_suggestions/:match_suggestion_id/acceptance */
  create: (
    params: { matchSuggestionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/overview/match_suggestions/:match_suggestion_id/acceptance', params, options),
    method: 'post',
  }),
}
